import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CryptoService 
{
  private readonly HOST:string  = environment.BASE_URL
  
  constructor(
    private httpClient:HttpClient
  ) {}

  decryptData(data:string):Observable<string>
  {
    const url = `${this.HOST}/decrypt`

    return this.httpClient.get<string>(url, {params:{data}})
  }
}
